import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { INewsPagedRequest } from '../../../../model/apm/news/request/news-paged-request';
import { INewsAddEditRequest } from '../../../../model/apm/news/request/news-add-edit-request';
import { INewsListResponse } from '../../../../model/apm/news/response/news-list-response';
import { INewsResponse } from '../../../../model/apm/news/response/news-response';
import { INewsCategoryResponse } from '../../../../model/apm/news/response/news-category-response';

const defaultPath = 'News';

// Paginação 0-based; a API limita PageSize a 100
const list = async (params: INewsPagedRequest): Promise<Pagination<INewsListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: {
            Term: params.term || undefined,
            CategoryId: params.categoryId,
            IsPublished: params.isPublished,
            Page: params.page,
            PageSize: params.pageSize,
        }
    }).then((response) => Object.assign(new Pagination<INewsListResponse>(), response.data));
};

const listCategories = async (): Promise<INewsCategoryResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Category`
    }).then((response) => response.data || []);
};

const getById = async (id: number): Promise<INewsResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: INewsAddEditRequest): Promise<INewsResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    }).then((response) => response.data);
};

const edit = async (id: number, params: INewsAddEditRequest): Promise<INewsResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    }).then((response) => response.data);
};

const changePublication = async (id: number, isPublished: boolean): Promise<INewsResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}/Publication`,
        data: { isPublished }
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const NewsAppService = { list, listCategories, getById, add, edit, changePublication, remove };
export default NewsAppService;
